import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ChatBot from "./ChatBot";
import "../styles/CaseProcessGuides.css";
import API_BASE_URL from "../config";
import {
  FaCarCrash,
  FaFileAlt,
  FaUserTie,
  FaCalendarCheck,
  FaPenFancy,
  FaBalanceScale,
  FaCheckCircle
} from "react-icons/fa";

export default function CaseProcessGuides() {
  const [brandName, setBrandName] = useState("Justivon");

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/site-settings`);
        const data = await res.json();

        if (data?.brandName) {
          setBrandName(data.brandName);
        }
      } catch (error) {
        console.error("Failed to load site settings", error);
      }
    };

    fetchSiteSettings();
  }, []);

  return (
    <div className="jus-case-guide-container">
      <Header />

      {/* HERO */}
      <section className="jus-case-guide-hero">
        <div className="jus-case-guide-hero-content">
          <span className="jus-case-guide-badge">
            <FaBalanceScale /> Legal Guidance
          </span>
          <h1 className="jus-case-guide-title">
            Case <span>Process Guides</span>
          </h1>
          <p className="jus-case-guide-subtitle">
            A simple step-by-step guide to understand how a legal case moves
            forward on {brandName} — from incident to resolution.
          </p>
        </div>
      </section>

      {/* PROCESS STEPS */}
      <main className="jus-case-guide-main">
        <div className="jus-case-guide-steps">

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaCarCrash />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 1: Incident Occurs</h3>
              <p>
                A legal issue arises — such as an accident, dispute, harassment,
                or family matter. Immediate safety and basic documentation are
                important.
              </p>
            </div>
          </div>

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaFileAlt />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 2: Case Registration</h3>
              <p>
                The user registers on {brandName} and submits essential case
                details including issue type, location, and description.
              </p>
            </div>
          </div>

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaUserTie />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 3: Solicitor Matching</h3>
              <p>
                {brandName} intelligently matches the case with verified
                solicitors based on practice area, experience, and location.
              </p>
            </div>
          </div>

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaCalendarCheck />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 4: Appointment & Consultation</h3>
              <p>
                The user schedules an appointment and consults with the solicitor
                via secure communication and scheduled meetings.
              </p>
            </div>
          </div>

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaPenFancy />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 5: Agreement & Documentation</h3>
              <p>
                Once both parties agree, a digital agreement is created, signed
                securely, and stored safely for future reference.
              </p>
            </div>
          </div>

          <div className="jus-case-guide-step">
            <div className="jus-case-guide-icon">
              <FaBalanceScale />
            </div>
            <div className="jus-case-guide-content">
              <h3>Step 6: Case Progress & Resolution</h3>
              <p>
                The solicitor manages hearings, filings, and legal proceedings
                while the user receives real-time updates until resolution.
              </p>
            </div>
          </div>

        </div>

        {/* NOTE */}
        <div className="jus-case-guide-note">
          <FaCheckCircle className="guide-icon"/>
          <p>
            {brandName} acts solely as a legal facilitation platform and does not
            provide legal advice directly. All legal services are delivered by
            independent solicitors.
          </p>
        </div>
      </main>

      <ChatBot />
      <Footer />
    </div>
  );
}
